module.exports = __webpack_public_path__ + "img/kuifeend.f6a30bca.png";